export interface FinalDiscountRequest {
  type: string;
  folio: number;
  fromReads: boolean;
  reason?: string;
  key?: string;
}

export interface FinalDiscountResult {
  required: boolean;
  authorized: boolean;
  requestPending: boolean;
  message: string;
}

export interface DiscountDialogs {
  confirm(message: string): boolean;
  prompt(message: string): string | null;
}

// La API relee las partidas en cada paso; el cliente no decide los kilos permitidos.
export async function authorizeFinalDiscount(
  prepare: (request: FinalDiscountRequest) => Promise<FinalDiscountResult>,
  document: FinalDiscountRequest,
  dialogs: DiscountDialogs
): Promise<boolean> {
  let state = await prepare(document);
  if (state.authorized) return true;
  if (!state.requestPending) {
    if (!dialogs.confirm(state.message + "\n\n¿Solicitar autorización a Absys?")) return false;
    const reason = dialogs.prompt("Motivo del descuento (por ejemplo: negociación dividida en varias facturas):");
    if (!reason || !reason.trim()) return false;
    state = await prepare({ ...document, reason: reason.trim() });
    if (state.authorized) return true;
  }
  const key = dialogs.prompt(state.message + "\n\nCLAVE de la tabla dinámica ID 286 para esta sucursal y este PR:");
  if (!key || !key.trim()) return false;
  state = await prepare({ ...document, key: key.trim() });
  return state.authorized;
}

export interface FinalInvoiceDocument { type: string; folio: number; }
export class PendingDiscountQuoteError<T extends FinalInvoiceDocument> extends Error {
  constructor(public quote: T, error: unknown) { super(String(error)); }
}

// Reservar y guardar el PR real antes de solicitar la CLAVE de ID 286.
export async function invoiceFromFinalQuote<T extends FinalInvoiceDocument>(
  saveQuote: () => Promise<T>, authorize: (quote: T) => Promise<boolean>, convert: (quote: T) => Promise<T>
): Promise<T> {
  const quote = await saveQuote();
  if (!quote || quote.type !== "PR" || quote.folio <= 0) throw new Error("No se confirmó el PR final. No se inició la facturación.");
  try {
    if (!(await authorize(quote))) return quote;
  } catch (error) {
    throw new PendingDiscountQuoteError(quote, error);
  }
  return convert(quote);
}
